export enum EManagementMode {
  MANUAL = "Manual",
  SEMI_AUTO = "Semi-Auto",
  AUTO_AI = "Auto-AI",
}
